// MSW Mock Setup
// This module provides mocking capabilities for API services during development and testing

// Browser setup (for development)
export { worker, startWorker } from './browser'

// Handlers
export { handlers } from './handlers'

// Mock data utilities
export { mockScenarios, mockDataHelpers, createMockLinkData } from './mockData'
export type { MockLinkData } from './mockData'

// Test utilities
export { testScenarios, runAllTests } from './testUtils'
export type { MockTestResult } from './testUtils'

// Node.js setup (for testing) - only export types in browser build
export type * from './server'

// Enable mocking in development
export const enableMocking = async () => {
    if (import.meta.env.DEV && import.meta.env.VITE_ENABLE_MOCKS === 'true') {
        const { startWorker } = await import('./browser')
        await startWorker()
        
        // Load test utilities in development
        if (import.meta.env.DEV) {
            await import('./testUtils')
        }
        
        return true
    }
    return false
}

// Utility to check if mocking is enabled
export const isMockingEnabled = () => {
    return import.meta.env.DEV && import.meta.env.VITE_ENABLE_MOCKS === 'true'
}